var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.active && _vm.$store.state.fahrttyp === 'ascent')?_c('div',{staticClass:"container marker"},[_vm._v("\n    "+_vm._s(_vm.$t('fahrtView.label.reservationFeeHint'))+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }